import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles(() =>
  createStyles({
    root: { lineHeight: 1, color: 'inherit' },
  })
);
